import React from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import Reveal from './Reveal';
import OptimizedImage from './OptimizedImage';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="section bg-gray-50">
      <div className="container">
        <Reveal>
        <Reveal className="text-center mb-12" delay={0.05}>
          <h2 className="section-title">お問い合わせ</h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-center">
            お気軽にご連絡くださいね！<br />
            LINEでは、うのつのぶこAIがすぐに応対します。<br />
            地域の声をお聞かせください。
          </p>
        </Reveal>

        <div className="max-w-3xl mx-auto">
          {/* 連絡先カード */}
          <Reveal className="bg-white rounded-lg shadow p-6 mb-6" delay={0.15}>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <MessageCircle className="w-5 h-5 mr-3 text-pink-500 mt-1" />
                  <div>
                    <div className="font-semibold text-gray-800">LINE（うのつのぶこAIが応対）</div>
                    <a
                      href="https://line.me/R/ti/p/@296ekiii"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-pink-600 text-sm hover:underline break-all"
                    >
                      https://line.me/R/ti/p/@296ekiii
                    </a>
                  </div>
                </li>
                <li className="flex items-center">
                  <Phone className="w-5 h-5 mr-3 text-pink-500" />
                  <a href="tel:09034733872" className="text-gray-800 hover:underline">090-3473-3872</a>
                </li>
                <li className="flex items-center">
                  <Mail className="w-5 h-5 mr-3 text-pink-500" />
                  <a href="mailto:ns821826hs117@gmail.com" className="text-gray-800 hover:underline">ns821826hs117@gmail.com</a>
                </li>
              </ul>
            </Reveal>

          {/* QRコードのみ */}
          <Reveal className="bg-white rounded-lg shadow p-6 text-center" delay={0.3}>
            <div className="mb-3 font-semibold text-gray-800">LINE QRコード</div>
            <OptimizedImage
              src="/line_qr_code.jpg"
              alt="LINE QRコード"
              className="mx-auto h-64 w-auto rounded"
              widths={[320, 480, 640]}
              sizes="(max-width: 640px) 90vw, 480px"
            />
          </Reveal>
        </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;

